// src/components/ExportButton.jsx
import React, { useState } from 'react';
import { Button, message } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

/**
 * Shared export button. Shows a spinner while `onExport` is pending and
 * `errorMessage` if it fails.
 */
export default function ExportButton({ onExport, children, disabled, errorMessage, ...buttonProps }) {
  const [exporting, setExporting] = useState(false);

  const handleClick = async () => {
    setExporting(true);
    try {
      await onExport();
    } catch (error) {
      console.error('Export failed', error);
      if (errorMessage) message.error(errorMessage);
    } finally {
      setExporting(false);
    }
  };

  return (
    // Spread first so callers cannot override these props.
    <Button
      {...buttonProps}
      type='primary'
      icon={<DownloadOutlined />}
      loading={exporting}
      disabled={disabled}
      onClick={handleClick}
    >
      {children}
    </Button>
  );
}
